import React from 'react'

import { UpdateCampusESPConfiguration } from './integration-service'
import { State } from './integrationsReducer'

interface Context {
  fetchIntegrations: () => void
  onActivateDocsToggle: ({ checked, type }: { checked: boolean; type: 'slate' | 'sftp' }) => void
  onActivateHandraisersToggle: ({ checked }: { checked: boolean }) => void
  onSendParentHandraisersBeforeStudent: ({ checked }: { checked: boolean }) => void
  onConfigurationChange: ({ type }: { type: 'slate' | 'sftp' }) => void
  onForceNewEasySlateIndexFields: () => void
  onKeyGeneration: () => void
  onKeyRemoval: () => void
  onSaveServerCredentials: ({ username, password }: { username: string; password?: string }) => void
  onSaveServerLocation: ({ hostname, port, path }: { hostname: string; port: number; path?: string }) => void
  onSaveSlateDomain: ({ domain }: { domain: string }) => void
  onTestSftpConnection: () => void
  onTestSlateConnection: ({ domain }: { domain: string }) => void
  onUpdateBatchTranscriptSetting: ({ isBatched }: { isBatched: boolean }) => void
  onCreateSFTPConfiguration: ({ type, username }: { type: 'campusESP'; username: string }) => void
  onUpdateSFTPConfiguration: ({ id, enabled, username }: UpdateCampusESPConfiguration) => void
  onRegenerateSFTPKey: ({ id }: { id: string }) => void
  onTestSFTPConfiguration: ({ id, username }: { id: string; username?: string }) => void
  scid?: number
  sftpTestSuccessful?: boolean
  slateTestSuccessful?: boolean
  state: State
  campusESPTestSuccessful?: boolean
}

const ctx: Context = {
  fetchIntegrations: () => {},
  onActivateDocsToggle: () => {},
  onActivateHandraisersToggle: () => {},
  onSendParentHandraisersBeforeStudent: () => {},
  onConfigurationChange: () => {},
  onForceNewEasySlateIndexFields: () => {},
  onKeyGeneration: () => {},
  onKeyRemoval: () => {},
  onSaveServerCredentials: () => {},
  onSaveServerLocation: () => {},
  onSaveSlateDomain: () => {},
  onTestSftpConnection: () => {},
  onTestSlateConnection: () => {},
  onUpdateBatchTranscriptSetting: () => {},
  onCreateSFTPConfiguration: () => {},
  onUpdateSFTPConfiguration: () => {},
  onRegenerateSFTPKey: () => {},
  onTestSFTPConfiguration: () => {},
  state: {
    isLoading: true,
    hasError: false,
  },
}

const IntegrationConfigurationContext = React.createContext(ctx)

export default IntegrationConfigurationContext
